// Leaf module of plain constants. Keep it import-free so it can be consumed
// by both segment.utils and the vuex store without creating import cycles.
export const ACQUISITION_COOKIE = 'ahaSegment'
export const ACQUISITION_FLAG = 'release-AHA-43253-acquisition-signal-log'
export const SIGNAL_TTL_DAYS = 14
